<template>
  <div class="cubes">
    <div class="cube">
      <EditBtn v-if="!edit" @click="edit=true" class="topright" :style="{boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', zIndex: 10}"/>
      <div class="cube-body" :class="edit ? 'edit' : ''" :style="{gridTemplateColumns: edit ? '1fr' : '1fr 300px'}">
        <template v-if="!edit">
          <div class="fieldsIng">
            <div :style="{marginBottom: '10px'}"><div><span v-for="n in '顯示'" :key="`info-${i}-${n}`">{{n}}</span></div><div :style="{textAlign:'center'}">:</div>
            <switchVue :style="{marginBlock: 'auto'}" :defaultValue="org.showLabelInfos" @update="saveShow({ showLabelInfos: !org.showLabelInfos })"/></div>
            <div v-for="(info, i) in (org.LabelInfos || [])" :key="`info-${i}`">
              <div><span v-for="n in info.name" :key="`info-${i}-${n}`">{{n}}</span></div>
              <div :style="{textAlign:'center'}">:</div>
              <div>{{info.value||'-'}}</div>
            </div>
          </div>
          <div>
            <div  class="fieldsIng">
              <div><div><span v-for="n in '顯示'" :key="`info-${i}-${n}`">{{n}}</span></div><div :style="{textAlign:'center'}">:</div>
              <switchVue :style="{marginBlock: 'auto'}" :defaultValue="org.showNutritionFacts" @update="saveShow({ showNutritionFacts: !org.showNutritionFacts })"/></div>
            </div>
            <table :style="{marginTop: '10px'}">
              <thead class="table-top">
                <tr><th colspan="3">營養標示</th></tr>
              </thead>
              <tbody class="table-top">
                <tr>
                  <td :style="{width: '7em'}">每一份量</td>
                  <td>{{org.NutritionFacts?.servingSize}}{{org.NutritionFacts?.servingUnit}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>本包裝含</td>
                  <td>{{org.NutritionFacts?.servingCount}}份</td>
                  <td></td>
                </tr>
              </tbody>
              <thead class="table-container">
                <tr>
                  <th></th>
                  <th>每份</th>
                  <th>每100{{org.NutritionFacts?.servingUnit || '公克'}}</th>
                </tr>
              </thead>
              <tbody class="table-container">
                <tr v-for="({layer, name, unit, total}, i) in (org.NutritionFacts?.Ingredient||[])" :key="`ing-${i}`">
                  <td><span v-if="layer"></span>{{name}}</td>
                  <td>{{unit}}</td>
                  <td>{{total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <template v-if="org.NutritionFactsImage">
            <div></div>
          </template>
        </template>
        <template v-else>
          <div class="fieldsIng">
            <div v-for="(info, i) in infos" :key="`info-${i}`">
              <button class="remove" @click="infos.splice(i, 1)"></button>
              <button class="add" @click="infos.splice(i+1, 0, { name: '', value: '' })"></button>
              <input type="text"  v-model="infos[i].name">
              <!-- <Input :defaultValue="info.name" @input="infos[i].name=$event"  :placeholder="'名稱'"/> -->
              <div :style="{textAlign:'center'}">:</div>
              <!-- <Input :defaultValue="info.value" @input="infos[i].value=$event"  :placeholder="'內容'"/> -->
              <input type="text" v-model="infos[i].value">
            </div>
          </div>
          <table :style="{marginTop: '20px'}">
            <thead class="table-top">
              <tr><th colspan="6">營養標示</th></tr>
            </thead>
            <tbody class="table-top">
              <tr>
                <td :colspan="2" :style="{width: '7em'}">每一份量</td>
                <td><input type="text" v-model="NutritionFacts.servingSize" :style="{width: '115px'}">
                    <input type="text" v-model="NutritionFacts.servingUnit" :style="{width: '115px'}">
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td :colspan="2">本包裝含</td>
                <td><div :style="{display:'flex'}"><input type="text" v-model="NutritionFacts.servingCount" :style="{width: '115px'}">份</div></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead class="table-container">
              <tr>
                <th></th>
                <th :style="{width:'230px'}"></th>
                <th :style="{maxWidth:'230px'}">每份</th>
                <th :style="{width:'230px'}">每100公克</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="table-container">
              <tr v-for="({}, i) in NutritionFacts.Ingredient" :key="`ing-${i}`">
                <td>
                  <button v-if="NutritionFacts.Ingredient[i].layer" @click="NutritionFacts.Ingredient[i].layer=0"
                  class="layer0"></button>
                  <button v-else @click="NutritionFacts.Ingredient[i].layer=1"
                  class="layer1"></button>
                </td>
                <td :class="`layer${NutritionFacts.Ingredient[i].layer}`">
                  <input type="text" v-model="NutritionFacts.Ingredient[i].name">
                </td>
                <td><input type="text" v-model="NutritionFacts.Ingredient[i].unit"></td>
                <td><input type="text" v-model="NutritionFacts.Ingredient[i].total"></td>
                <td>
                  <button class="remove" @click="NutritionFacts.Ingredient.splice(i, 1)"></button>
                </td>
                <td>
                  <button class="add" @click="NutritionFacts.Ingredient.splice(i+1, 0, JSON.parse(JSON.stringify(NutritionFacts.Ingredient[i])))"></button>
                </td>
              </tr>
            </tbody>
          </table>
          <Btns :style="{height: '40px', paddingBottom: '0px', marginTop: '40px'}" @cancel="edit=false" @save="save"/>
        </template>
      </div>
    </div>
    <div class="cube">
      <div class="cube-body" :class="editImage ? 'edit' : ''" :style="{gridTemplateColumns: '1fr'}">
        <div class="title">營養標示圖片
          <label v-if="!org.NutritionFactsImage" class="addimage" for="addimage"><span></span><input type="file" id="addimage" @change="upload">新增營養標示圖片</label>
          <switchVue v-else :style="{marginBlock: 'auto'}" :defaultValue="org.showNutritionFactsImage" @update="saveShow({ showNutritionFactsImage: !org.showNutritionFactsImage })"/>
        </div>
        <label class="delete" v-if="org.NutritionFactsImage" :style="{marginTop:'20px'}">
          <img :src="`${VUE_APP_HOST}${org.NutritionFactsImage}`" :alt="`${org.name}-營養標示`">
          <button @click="deleteImg=org.NutritionFactsImage"></button>
        </label>
      </div>
    </div>
    <DialogDef2 v-if="deleteImg" :show="deleteImg" :label="'刪除營養標示圖片'" @close="deleteImg=null">
      <div class="dialogConfirm">
        <div>確定要刪除營養標示圖片嗎?</div>
        <BtnsS @cancel="deleteImg=null" @save="deleteImage" :save="'確定'"/>
      </div>
    </DialogDef2>
  </div>
</template>

<script>
// import Input from '../../../../components/input/normal.vue'
import switchVue from '../../../../components/radio/switch.vue'
import EditBtn from '../../../../components/btn/edit.vue'
import Btns from '../../../../components/btn/btns'
import { postapi, getapi } from '../../../../store/fetch'
const { VUE_APP_HOST } = process.env
export default {
  props: ['org'],
  components: { EditBtn, Btns, switchVue },
  data () {
    return {
      VUE_APP_HOST,
      edit: false,
      NutritionFacts: null,
      infos: null,
      NutritionFactsImage: null,
      deleteImg: null,
      labelSample: []
    }
  },
  async mounted () {
    this.labelSample = await getapi('selections/LabelSample')
  },
  computed: {
  },
  watch: {
    edit () {
      if (this.edit) {
        if (this.org.NutritionFactsImage) {
          this.NutritionFactsImage = this.org.NutritionFactsImage
        } else {
          this.NutritionFactsImage = null
        }
        if (this.org.NutritionFacts) {
          this.NutritionFacts = JSON.parse(JSON.stringify(this.org.NutritionFacts))
        } else {
          this.NutritionFacts = {
            servingSize: 20,
            servingUnit: '公克',
            servingCount: 1,
            Ingredient: [
              { layer: 0, name: '熱量', unit: '大卡', total: '大卡' },
              { layer: 0, name: '蛋白質', unit: '公克', total: '公克' },
              { layer: 0, name: '脂肪', unit: '公克', total: '公克' },
              { layer: 1, name: '飽和脂肪', unit: '公克', total: '公克' },
              { layer: 1, name: '反式脂肪', unit: '公克', total: '公克' },
              { layer: 0, name: '碳水化合物', unit: '公克', total: '公克' },
              { layer: 1, name: '糖', unit: '公克', total: '公克' },
              { layer: 1, name: '膳食纖維', unit: '公克', total: '公克' },
              { layer: 0, name: '鈉', unit: '毫克', total: '毫克' }
            ]
          }
        }
        if (this.org.LabelInfos) {
          this.infos = JSON.parse(JSON.stringify(this.org.LabelInfos))
        } else {
          this.infos = ((this.labelSample && (this.labelSample.length > 0)) ? this.labelSample : [
            { name: '品名', value: this.org.name },
            { name: '成份', value: null },
            { name: '淨重', value: '50公克' },
            { name: '有效期限', value: '3天' },
            { name: '過敏原', value: null },
            { name: '製造商', value: null },
            { name: '地址', value: null }
          ]).map(({ name, value }) => { return { name, value: value ? value.replaceAll('{name}', this.org.name) : null } })
        }
      }
    }
  },
  methods: {
    async upload (ev) {
      const image = await this.$store.dispatch('uploadFile', { event: ev, folder: 'product' })
      console.log('[image]', image)
      const r = await postapi(`rest_product/single/${this.org._id}`, { NutritionFactsImage: `/product/${image.filename}` })
      console.log('[upload]', r)
      if (r) {
        this.NutritionFactsImage = r.NutritionFactsImage
        this.$emit('update', r)
      }
    },
    async deleteImage () {
      const r = await postapi(`rest_product/single/${this.org._id}`, { NutritionFactsImage: null })
      if (r) {
        this.NutritionFactsImage = r.NutritionFactsImage
        this.$emit('update', r)
        this.deleteImg = null
      }
    },
    async saveShow (body) {
      const r = await postapi(`rest_product/single/${this.org._id}`, body)
      if (r) {
        this.$emit('update', r)
      }
    },
    async save () {
      const r = await postapi(`rest_product/single/${this.org._id}`, {
        LabelInfos: this.infos,
        NutritionFacts: this.NutritionFacts
      })
      if (r) {
        this.$emit('update', r)
        this.edit = false
      }
    }
  }
}
</script>
<style lang="scss">
.cube-body {
  select {
    text-align-last: center;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 24px;
  font-weight: 400;
  color: var(--color-pri);
  text-align: start;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.cubes {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: calc(100vh - 200px)!important;
  height: calc(100vh - 200px);
  min-height: unset!important;
  overflow-y: auto!important;
  align-items: flex-start;
  justify-content: flex-start;
}
.dialogConfirm {
  display: flex;
  flex-direction: column;
  font-size: 24px;
  padding: 30px;
  gap: 20px;
}
img {
  width: 400px;
  height: fit-content;
  min-height: fit-content;
  resize: both;
  background-color: #CACACA;
  min-height: 100px;
}
label {
  max-width: 400px;
}
.delete {
  z-index: 1;
  width: 400px;
  max-width: 400px;
  position: relative;
}
.delete > button {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  margin: auto;
  display: block;
  width: 50px;
  height: 50px;
  background-color: #00000099;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    display: inline-flex;
    width: 35px;
    height: 35px;
    mask-image: url(/svg/btn/closeDialog.svg);
    background-color: #FFFFFF;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
}
.filter {
  margin-top: 20px;
  padding-right: 60px;
}
.addimage {
  margin-top: 10px;
  margin-left: auto;
  width: 265px;
  height: 50px;
  background-color: var(--color-pri);
  display: flex;
  border-radius: 25px;
  color: #FFFFFF;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  letter-spacing: .1em;
  font-weight: 400;
  font-size: 18px;
  gap: 10px;
  text-align: start;
  white-space: nowrap;
  input[type=file] {
    display: none;
  }
  &>span {
    background-color: #FFFFFF;
    mask-image: url(svg/btn/add.svg);
    display: inline-flex;
    width: 25px;
    height: 25px;
    mask-position: center;
    mask-size: contain;
    mask-repeat: no-repeat;
  }
}
.cube {
  margin-top: 20px;
  flex: 1;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  width: -webkit-fill-available;
  display: grid;
  grid-template-rows: 1fr 47px;
  position: relative;
  overflow-y: auto;
  height: fit-content;
  overflow-y: hidden;
  min-height: fit-content;
}
.cube-body {
  flex:1;
  display: grid;
  position: relative;
  padding-block: 25px 28px;
  padding-inline: 30px 60px;
  table {
    width: 300px;
    border-collapse: collapse;
    border: 1px solid var(--color-pri);
    thead {
      background-color: var(--color-pri);
      color: #FFFFFF;
    }
    tbody.table-top {
      background-color: #FFFFFF;
      color: var(--color-pri);
      text-align: start;
      td:first-child {
        padding-inline: .8em;
      }
    }
    thead.table-container {
      text-align: end;
      th:last-child {
        padding-right: .8em;
      }
    }
    tbody.table-container {
      background-color: #FFFFFF;
      color: var(--color-pri);
      text-align: end;
      td:first-child {
        padding-inline: .8em;
        text-align: start;
        span {
          display: inline-flex;
          width: 1em;
        }
      }
      td:last-child {
        padding-right: .8em;
      }
    }

  }
}
.fieldsIng {
  display: flex;
  flex-direction: column;
  text-align: start;
  font-size: 20px;
  color: var(--color-pri);
  &>div{
    display: grid;
    grid-template-columns: 4em 1em 1fr;
    &>div:nth-child(1) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
  }
}
.cube-body.edit {
  max-width: calc(100vw - 1105px);
  .fieldsIng {
    max-width: calc(100vw - 1155px);
    &>div{
      display: grid;
      grid-template-columns: 40px 40px 4em 1em 1fr;
    }
    button {
      width: 1em;
      height: 1em;
      mask-position: center;
      mask-size: contain;
      background-color: #CACACA;
      mask-repeat: no-repeat;
      &.remove {
        &:hover {background-color: var(--highlight);}
        mask-image: url(/svg/btn/del1.svg);
      }
      &.add {
        &:hover {background-color: var(--color-pri);}
        mask-image: url(/svg/btn/add.svg);
      }
    }
  }
  table {
    font-size: 18px;
    border-collapse: collapse;
    border: 1px solid var(--color-pri);
    width: 840px;
    max-width: 840px;
    tbody>tr:hover {
      background-color: #FFFFFF;
    }
  thead {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
  tbody.table-top {
    background-color: #FFFFFF;
    color: var(--color-pri);
    text-align: start;
    td:first-child {
      padding-inline: .8em;
    }
  }
  thead.table-container {
    text-align: end;
    th:last-child {
      padding-right: .8em;
    }
  }
  tbody.table-container {
    background-color: #FFFFFF;
    color: var(--color-pri);
    line-height: 2em;
    td {
      max-width: 230px;
    }
    input[type=text] {
      text-align: end;
      line-height: 1.5em;
      height: 1.5em;
      width: -webkit-fill-available;
      &:hover {
        background-color: #cacaca2b;
      }
      &:focus {
        background-color: var(--color-bar);
      }
    }
    button {
      width: 1em;
      height: 1em;
      mask-position: center;
      mask-size: contain;
      background-color: #CACACA;
      mask-repeat: no-repeat;
      &.layer0 {
        mask-image: url(/svg/btn/arrowRight.svg);
        transform: rotate(180deg);
        &:hover{background-color: var(--highlight);}
      }
      &.layer1 {
        mask-image: url(/svg/btn/arrowRight.svg);
        &:hover {background-color: var(--color-pri);}
      }
      &.remove {
        &:hover {background-color: var(--highlight);}
        mask-image: url(/svg/btn/del1.svg);
      }
      &.add {
        &:hover {background-color: var(--color-pri);}
        mask-image: url(/svg/btn/add.svg);
      }
    }
    td:first-child {
      span {
        display: inline-flex;
        width: 1em;
      }
    }
    td:nth-child(2) {
      input[type=text] {
        text-align: start;
      }
    }
    td:nth-child(2), td:nth-child(3), td:nth-child(4) {
      width: 230px;
      max-width: 230px;
      &.layer1 {
        padding-left: 1em;
      }
      input[type=text] {
        width: -webkit-fill-available;
      }
    }
    td:nth-child(5), td:nth-child(6) {
      padding-inline: .8em;
      min-width: 1.8em;
    }
  }

  }
}
.topright {
  position: absolute;
  right: 20px;
  top: 13px;
}
</style>
